function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { getFontFamily, getButtonPrimaryColorBackground, getButtonPrimaryColorBorder, getButtonPrimaryColorText, getButtonSecondaryColorBackground, getButtonSecondaryColorBorder, getButtonSecondaryColorText, getButtonDangerColorBackground, getButtonDangerColorBorder, getButtonDangerColorText, getButtonPaddingX, getButtonPaddingY, getButtonLabelFontSize, getButtonLabelFontWeight, getButtonLabelTextTransform, getActionPrimaryColorText, getActionSecondaryColorText, getButtonBorderRadius, getFormBorderRadius, getFormAccentColor, getFormPlaceholderTextColor, getInputFieldPaddingX, getInputFieldPaddingY, getColorBorder, getFormHighlightColorBorder, getColorText, getColorSecondaryText, getColorBackground, getOffsetBackgroundColor, getFormBackgroundColor, getBadgeBorderRadius, getOverlayBorderRadius, getOverlayBackdropColor, getPrimaryColor, getBadgeNeutralColorBorder, getBadgeNeutralColorBackground, getBadgeNeutralColorText, getBadgeSuccessColorBorder, getBadgeSuccessColorText, getBadgeSuccessColorBackground, getBadgeWarningColorBackground, getBadgeWarningColorBorder, getBadgeWarningColorText, getBadgeDangerColorBackground, getBadgeDangerColorBorder, getBadgeDangerColorText, getBadgeLabelFontSize, getBadgeLabelFontWeight, getBadgeLabelTextTransform, getBadgePaddingX, getBadgePaddingY, getHeadingXlFontSize, getHeadingMdFontSize, getHeadingSmFontSize, getHeadingXsFontSize, getHeadingLgFontSize, getBodyMdFontSize, getBodySmFontSize, getLabelMdFontSize, getLabelSmFontSize, getActionPrimaryTextDecorationColor, getActionPrimaryTextTransform, getActionSecondaryTextDecorationColor, getActionSecondaryTextTransform, getTableRowPaddingY } from "./tokenOverrides";
import { CONNECT_ELEMENTS_OVERLAYS_DEFAULT, CONNECT_ELEMENTS_OVERLAY_ZINDEX_DEFAULT, themeValueDefaults } from "./appearanceOptionsDefaults";
/**
 * Layer 2 -> Layer 2 mapping: We map ConnectJS options (overlays and variables) to their default values, which are determined by other ConnectJS options.
 * Default values mapping: For example, `buttonPrimaryColorBackground` defaults to `colorPrimary` if not specified. This happens within the `getButtonPrimaryColorBackground` function.
 */ export const getAppearanceValuesWithDefaults = ({ overlays, variables }, shouldThemeForMobileSdk)=>{
    const theme = variables == null ? {} : _object_spread({}, variables);
    const isMobileSdkTheme = !!shouldThemeForMobileSdk;
    return {
        overlays: overlays || CONNECT_ELEMENTS_OVERLAYS_DEFAULT,
        variables: {
            // Font Family
            fontFamily: getFontFamily(theme),
            // Primary Button
            colorPrimary: getPrimaryColor(theme),
            buttonPrimaryColorBackground: getButtonPrimaryColorBackground(theme),
            buttonPrimaryColorBorder: getButtonPrimaryColorBorder(theme),
            buttonPrimaryColorText: getButtonPrimaryColorText(theme),
            // Secondary Button
            buttonSecondaryColorBackground: getButtonSecondaryColorBackground(theme),
            buttonSecondaryColorBorder: getButtonSecondaryColorBorder(theme),
            buttonSecondaryColorText: getButtonSecondaryColorText(theme),
            // Danger Button
            buttonDangerColorBackground: getButtonDangerColorBackground(theme),
            buttonDangerColorBorder: getButtonDangerColorBorder(theme),
            buttonDangerColorText: getButtonDangerColorText(theme),
            // Button Padding
            buttonPaddingX: getButtonPaddingX(theme, isMobileSdkTheme),
            buttonPaddingY: getButtonPaddingY(theme, isMobileSdkTheme),
            // Button Label
            buttonLabelFontSize: getButtonLabelFontSize(theme, isMobileSdkTheme),
            buttonLabelFontWeight: getButtonLabelFontWeight(theme, isMobileSdkTheme),
            buttonLabelTextTransform: getButtonLabelTextTransform(theme),
            // Links
            actionPrimaryColorText: getActionPrimaryColorText(theme),
            actionPrimaryTextDecorationLine: theme.actionPrimaryTextDecorationLine || themeValueDefaults.actionPrimaryTextDecorationLine,
            actionPrimaryTextDecorationColor: getActionPrimaryTextDecorationColor(theme),
            actionPrimaryTextDecorationStyle: theme.actionPrimaryTextDecorationStyle || themeValueDefaults.actionPrimaryTextDecorationStyle,
            actionPrimaryTextDecorationThickness: theme.actionPrimaryTextDecorationThickness || themeValueDefaults.actionPrimaryTextDecorationThickness,
            actionPrimaryTextTransform: getActionPrimaryTextTransform(theme),
            actionSecondaryColorText: getActionSecondaryColorText(theme),
            actionSecondaryTextDecorationLine: theme.actionSecondaryTextDecorationLine || themeValueDefaults.actionSecondaryTextDecorationLine,
            // In embedded, we underline all secondary links by default, but not the primary links
            actionSecondaryTextDecorationColor: getActionSecondaryTextDecorationColor(theme),
            actionSecondaryTextDecorationStyle: theme.actionSecondaryTextDecorationStyle || themeValueDefaults.actionSecondaryTextDecorationStyle,
            actionSecondaryTextDecorationThickness: theme.actionSecondaryTextDecorationThickness || themeValueDefaults.actionSecondaryTextDecorationThickness,
            actionSecondaryTextTransform: getActionSecondaryTextTransform(theme),
            // Border Color
            colorBorder: getColorBorder(theme),
            formHighlightColorBorder: getFormHighlightColorBorder(theme),
            // Form
            formAccentColor: getFormAccentColor(theme),
            inputFieldPaddingX: getInputFieldPaddingX(theme, isMobileSdkTheme),
            inputFieldPaddingY: getInputFieldPaddingY(theme, isMobileSdkTheme),
            formPlaceholderTextColor: getFormPlaceholderTextColor(theme),
            // Text
            colorText: getColorText(theme),
            colorSecondaryText: getColorSecondaryText(theme),
            // Background
            colorBackground: getColorBackground(theme),
            offsetBackgroundColor: getOffsetBackgroundColor(theme),
            formBackgroundColor: getFormBackgroundColor(theme),
            // Feedback Colors
            colorDanger: theme.colorDanger || themeValueDefaults.colorDanger,
            // Badge Colors
            badgeNeutralColorBackground: getBadgeNeutralColorBackground(theme),
            badgeNeutralColorBorder: getBadgeNeutralColorBorder(theme),
            badgeNeutralColorText: getBadgeNeutralColorText(theme),
            badgeSuccessColorBackground: getBadgeSuccessColorBackground(theme),
            badgeSuccessColorBorder: getBadgeSuccessColorBorder(theme),
            badgeSuccessColorText: getBadgeSuccessColorText(theme),
            badgeWarningColorBackground: getBadgeWarningColorBackground(theme),
            badgeWarningColorBorder: getBadgeWarningColorBorder(theme),
            badgeWarningColorText: getBadgeWarningColorText(theme),
            badgeDangerColorBackground: getBadgeDangerColorBackground(theme),
            badgeDangerColorBorder: getBadgeDangerColorBorder(theme),
            badgeDangerColorText: getBadgeDangerColorText(theme),
            // Badge Padding
            badgePaddingX: getBadgePaddingX(theme),
            badgePaddingY: getBadgePaddingY(theme),
            // Badge Label
            badgeLabelFontSize: getBadgeLabelFontSize(theme),
            badgeLabelFontWeight: getBadgeLabelFontWeight(theme),
            badgeLabelTextTransform: getBadgeLabelTextTransform(theme),
            // Border Sizing
            borderRadius: theme.borderRadius,
            buttonBorderRadius: getButtonBorderRadius(theme),
            formBorderRadius: getFormBorderRadius(theme),
            badgeBorderRadius: getBadgeBorderRadius(theme),
            overlayBorderRadius: getOverlayBorderRadius(theme),
            // Overlay
            overlayZIndex: theme.overlayZIndex || CONNECT_ELEMENTS_OVERLAY_ZINDEX_DEFAULT,
            overlayBackdropColor: getOverlayBackdropColor(theme),
            // Spacing
            spacingUnit: theme.spacingUnit || themeValueDefaults.spacingUnit,
            // Font Size
            fontSizeBase: theme.fontSizeBase || themeValueDefaults.fontSizeBase,
            // Heading Typography
            headingXlFontSize: getHeadingXlFontSize(theme),
            headingXlFontWeight: theme.headingXlFontWeight || themeValueDefaults.headingXlFontWeight,
            headingXlTextTransform: theme.headingXlTextTransform || themeValueDefaults.headingXlTextTransform,
            headingLgFontSize: getHeadingLgFontSize(theme),
            headingLgFontWeight: theme.headingLgFontWeight || themeValueDefaults.headingLgFontWeight,
            headingLgTextTransform: theme.headingLgTextTransform || themeValueDefaults.headingLgTextTransform,
            headingMdFontSize: getHeadingMdFontSize(theme),
            headingMdFontWeight: theme.headingMdFontWeight || themeValueDefaults.headingMdFontWeight,
            headingMdTextTransform: theme.headingMdTextTransform || themeValueDefaults.headingMdTextTransform,
            headingSmFontSize: getHeadingSmFontSize(theme),
            headingSmFontWeight: theme.headingSmFontWeight || themeValueDefaults.headingSmFontWeight,
            headingSmTextTransform: theme.headingSmTextTransform || themeValueDefaults.headingSmTextTransform,
            headingXsFontSize: getHeadingXsFontSize(theme),
            headingXsFontWeight: theme.headingXsFontWeight || themeValueDefaults.headingXsFontWeight,
            headingXsTextTransform: theme.headingXsTextTransform || themeValueDefaults.headingXsTextTransform,
            // Body Typography
            bodyMdFontSize: getBodyMdFontSize(theme),
            bodyMdFontWeight: theme.bodyMdFontWeight || themeValueDefaults.bodyMdFontWeight,
            bodySmFontSize: getBodySmFontSize(theme),
            bodySmFontWeight: theme.bodySmFontWeight || themeValueDefaults.bodySmFontWeight,
            // Label Typography
            labelMdFontSize: getLabelMdFontSize(theme),
            labelMdFontWeight: theme.labelMdFontWeight || themeValueDefaults.labelMdFontWeight,
            labelMdTextTransform: theme.labelMdTextTransform || themeValueDefaults.labelMdTextTransform,
            labelSmFontSize: getLabelSmFontSize(theme),
            labelSmFontWeight: theme.labelSmFontWeight || themeValueDefaults.labelSmFontWeight,
            labelSmTextTransform: theme.labelSmTextTransform || themeValueDefaults.labelSmTextTransform,
            // Table
            tableRowPaddingY: getTableRowPaddingY(theme)
        }
    };
};

//# sourceMappingURL=getAppearanceValuesWithDefaults.js.map